import { GoogleMapsContext } from 'providers/withApplicationContext';
import React from 'react';

export const useIsGoogleMapsLoaded = (): { isLoaded: boolean; error: Error | undefined } => {
  const { loaded, error } = React.useContext(GoogleMapsContext);

  return { isLoaded: BROWSER && loaded && window.google, error };
};
